import { API_DEV } from "constants/api";
import { NOTE_TYPE_SSE } from "constants/dbValues";

import { header, handleAPIResult, serialize, formatMaterialFilters } from "utils";

const pages = {
  admin: ["Speciality", "SpecialityType"],
  document: ["DocumentType"],
  tailgate: ["Risk", "Mean"],
  incident: ["Risk"],
  note: ["NoteType"],
  compliance: ["ComplianceType"],
  project: ["ProjectType"],
  user: ["UserType", "Job"],
  submission: ["ProjectType", "Region", "SubmissionState", "Speciality", "SpecialityType"],
  dashboard: ["ProjectType"],

  documents: ["DocumentType"],
  notes: ["NoteType"],
  compliances: ["ComplianceType"],
  projects: ["ProjectType"],
  users: ["UserType", "Job"],
  means: ["Risk"],
  suppliers: ["Region", "SpecialityType", "Speciality"],
  submissions: ["ProjectType", "Region", "SubmissionState", "AnalyzeType"],
};

export const selectService = {
  listForPage,
  list,

  listLicenses,

  listRisks,
  createRisk,
  updateRisk,

  listMeans,
  createMean,
  updateMean,

  listSuppliers,
  createSupplier,
  updateSupplier,
};

function listForPage(page) {
  return new Promise((resolve, reject) => {
    if (!(page in pages)) resolve([]);

    list(pages[page])
      .then((result) => resolve(result))
      .catch((error) => reject(error));
  });
}

function list(selects) {
  const getInfo = {
    method: "GET",
    headers: header(),
  };

  var qs = selects.map((select) => `models[]=${select}`).join("&");

  return new Promise((resolve, reject) => {
    fetch(API_DEV + "/selects?" + qs, getInfo)
      .then((result) => {
        handleAPIResult(result, reject);
        return result.json();
      })
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

function listSpecialities() {
  return list(["Speciality"]);
}

function listLicenses(filters = {}, material = {}) {
  const getInfo = {
    method: "GET",
    headers: header(),
  };

  var qs =
    Object.keys(material).length === 0
      ? serialize(filters)
      : formatMaterialFilters(filters, material);
  return new Promise((resolve, reject) => {
    fetch(API_DEV + "/licenses?" + qs, getInfo)
      .then((result) => {
        handleAPIResult(result, reject);
        return result.json();
      })
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

function listRisks(filters = {}, material = {}) {
  const getInfo = {
    method: "GET",
    headers: header(),
  };

  var qs =
    Object.keys(material).length === 0
      ? serialize(filters)
      : formatMaterialFilters(filters, material);
  return new Promise((resolve, reject) => {
    fetch(API_DEV + "/risks?" + qs, getInfo)
      .then((result) => {
        handleAPIResult(result, reject);
        return result.json();
      })
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

function createRisk(risk) {
  const postInfo = {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      ...header(),
    },

    body: JSON.stringify({
      risk: risk,
    }),
  };

  return new Promise((resolve, reject) => {
    fetch(API_DEV + "/risks", postInfo)
      .then((result) => {
        handleAPIResult(result, reject);
        return result.json();
      })
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

function updateRisk(risk) {
  const patchInfo = {
    method: "PATCH",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      ...header(),
    },

    body: JSON.stringify({
      risk: risk,
    }),
  };

  return new Promise((resolve, reject) => {
    fetch(API_DEV + "/risks/" + risk.id, patchInfo)
      .then((result) => {
        handleAPIResult(result, reject);
        return result.json();
      })
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

function listMeans(filters = {}, material = {}) {
  const getInfo = {
    method: "GET",
    headers: header(),
  };

  var qs =
    Object.keys(material).length === 0
      ? serialize(filters)
      : formatMaterialFilters(filters, material);
  return new Promise((resolve, reject) => {
    fetch(API_DEV + "/means?" + qs, getInfo)
      .then((result) => {
        handleAPIResult(result, reject);
        return result.json();
      })
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

function createMean(mean) {
  const postInfo = {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      ...header(),
    },

    body: JSON.stringify({
      mean: mean,
    }),
  };

  return new Promise((resolve, reject) => {
    fetch(API_DEV + "/means", postInfo)
      .then((result) => {
        handleAPIResult(result, reject);
        return result.json();
      })
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

function updateMean(mean) {
  const patchInfo = {
    method: "PATCH",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      ...header(),
    },

    body: JSON.stringify({
      mean: mean,
    }),
  };

  return new Promise((resolve, reject) => {
    fetch(API_DEV + "/means/" + mean.id, patchInfo)
      .then((result) => {
        handleAPIResult(result, reject);
        return result.json();
      })
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

function listSuppliers(filters = {}, material = {}) {
  const getInfo = {
    method: "GET",
    headers: header(),
  };

  var qs =
    Object.keys(material).length === 0
      ? serialize(filters)
      : formatMaterialFilters(filters, material);
  return new Promise((resolve, reject) => {
    fetch(API_DEV + "/suppliers?" + qs, getInfo)
      .then((result) => {
        handleAPIResult(result, reject);
        return result.json();
      })
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

function createSupplier(supplier) {
  const postInfo = {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      ...header(),
    },

    body: JSON.stringify({
      supplier: supplier,
    }),
  };

  return new Promise((resolve, reject) => {
    fetch(API_DEV + "/suppliers", postInfo)
      .then((result) => {
        handleAPIResult(result, reject);
        return result.json();
      })
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

function updateSupplier(supplier) {
  const patchInfo = {
    method: "PATCH",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      ...header(),
    },

    body: JSON.stringify({
      supplier: supplier,
    }),
  };

  return new Promise((resolve, reject) => {
    fetch(API_DEV + "/suppliers/" + supplier.id, patchInfo)
      .then((result) => {
        handleAPIResult(result, reject);
        return result.json();
      })
      .then((result) => {
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}
